<!--
/**
* @name: List.vue
* @description: 分销员管理列表页
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-select placeholder="请选择角色" clearable v-model="para.type">
          <k-option v-for="item in roleList" :key="item.value" :value="item.value" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入会员账号" clearable v-model="para.account"></k-input>
      </y-query-item>
      <y-query-item>
        <k-auto-complete
          style="width: 200px;"
          ref="au"
          :data="companyList"
          v-model="para.companyCode"
          key-field="code"
          value-field="name"
          search-field="name"
          layer-width=""
          placeholder="请选择所属推广公司"
        >
          <div slot-scope="{ row }" :key="row.code" class="list">
            <span class="name">{{ row.name }}</span>
          </div>
        </k-auto-complete>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input placeholder="请输入手机号码" clearable v-model="para.phone"></k-input>
      </y-query-item>
      <y-query-item>
        <k-auto-complete
          style="width: 200px;"
          ref="bu"
          :data="dealerList"
          v-model="shopCode"
          key-field="shopCode"
          value-field="shopName"
          search-field="shopName"
          layer-width=""
          placeholder="请选择所属门店"
        >
          <div slot-scope="{ row }" :key="row.shopCode" class="list">
            <span class="name">{{ row.shopName }}</span>
          </div>
        </k-auto-complete>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择销售渠道" clearable v-model="para.channelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="dataList" @sort="onSort" :height="$root.tableHeightXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="dataList && dataList.length" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <k-popup bind="v-if" okText="保存" title="修改密码" :show.sync="isShowPopup" @after-close="onClosePwd" @after-cancel="onCancelPwd" @after-ok="onSave">
      <div style="width: 650px;">
        <y-form titleAlign="right" titleWidth="100px" contentWidth="400px">
          <y-form-item title="新密码:" required>
            <k-input
              maxlength="10"
              placeholder="请设置由英文+数字组成的8-10位字符"
              v-validate="'minLength(8)|maxLength(10)|regex(/^(?![\\d]+$)(?![a-zA-Z]+$)(?![^\\da-zA-Z]+$).{8,10}/)'"
              block
              v-model="newPassword"
              clearable
            ></k-input>
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
  </y-view>
</template>

<script>
import {
  NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_PAGELIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
  NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_UPDATE_STATUS,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_UPDATE_PASSWORD,
} from "@/assets/modules/apiList";

const initPara = () => ({
  account: "",
  companyCode: "",
  phone: "",
  shopCode: [],
  channelCode: "",
  type: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      isLoading: false,
      createTimeSorter: true,
      dataList: [],
      roleList: [],
      shopCode: "",
      companyList: [],
      dealerList: [],
      channelList: [],
      para: initPara(),
      isShowPopup: false,
      newPassword: "",
      memberId: "",
      total: 0,
    };
  },
  methods: {
    initColumns() {
      const createTimeSorter = this.createTimeSorter;
      return [
        {
          name: "会员账号",
          field: "account",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "销售渠道",
          field: "channelName",
          style: {
            width: 150,
            textAlign: "center",
          },
        },
        {
          name: "角色",
          field: "typeName",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "所属门店",
          field: "shopName",
          style: {
            width: 120,
            textAlign: "center",
          },
        },
        {
          name: "所属推广公司",
          field: "companyName",
          style: {
            width: 120,
            textAlign: "center",
          },
        },
        {
          name: "状态",
          field: "status",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.status == 1}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "注册时间",
          field: "createTime",
          sorter: createTimeSorter,
          style: { textAlign: "center" },
        },
        {
          name: "操作",
          field: "action",
          style: {
            textAlign: "center",
            width: "100px",
          },
          customRender: (row) => {
            const previewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const changeButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onChangePwd(row);
                }}
              >
                修改密码
              </a>
            );
            return (
              <div>
                {previewButton}&#12288;{changeButton}
              </div>
            );
          },
        },
      ];
    },
    onSort({ type }) {
      type == 1 ? (this.para.orders = { asc: false, column: "createTime" }) : (this.para.orders = { asc: true, column: "createTime" });
      this.getMemberList();
    },
    getMemberList() {
      this.isLoading = true;
      this.para.shopCode = this.shopCode ? [this.shopCode] : [];
      let { para } = this;
      this.$fetch({
        api: NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_PAGELIST,
        para,
      }).then((res) => {
        this.dataList = res.pageList || [];
        this.total = res.total;
        this.isLoading = false;
      });
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getMemberList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getMemberList();
    },
    onReset() {
      this.para = initPara();
      this.shopCode = "";
      this.$refs.au.inputText = "";
      this.$refs.bu.inputText = "";
      this.getMemberList();
    },
    onChangePwd(row) {
      this.isShowPopup = true;
      this.memberId = row.id;
    },
    onClosePwd() {
      this.newPassword = "";
    },
    onCancelPwd() {
      this.newPassword = "";
    },
    onSave() {
      let { tip } = this.$root;
      if (!this.newPassword) {
        return tip("请输入新密码");
      } else {
        // let reg = /^(?![\\d]+$)(?![a-zA-Z]+$)(?![^\\da-zA-Z]+$).{8,10}/;
        // let reg = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+.])[a-zA-Z\d!@#$%^&*()_+.]{10,}/
        // if (!reg.test(this.newPassword)) {
        //   return tip("密码必须包含大小写字母、数字和特殊字符，且长度不小于10位");
        // }
        let reg = /^(?![\\d]+$)(?![a-zA-Z]+$)(?![^\\da-zA-Z]+$).{8,10}/;
        if (!reg.test(this.newPassword)) {
          return tip("请输入由英文+数字组成的8-10位字符");
        }
      }
      this.$fetch({
        api: NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_UPDATE_PASSWORD,
        para: { id: this.memberId, password: this.newPassword },
      })
        .then((res) => {
          this.isLoading = false;
          this.isShowPopup = false;
          this.newPassword = "";
          this.getMemberList();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onChangeStatus(row) {
      let { id } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.status == 1 ? "停用" : "启用"}该会员账号？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_SHOP_MEMBER_UPDATE_STATUS,
            para: {
              id,
              status: row.status == 1 ? 0 : 1,
             },
          })
            .then(() => {
              this.isLoading = false;
              this.getMemberList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onView(row) {
      const { id } = row;
      this.$controller.open({
        name: "distributorDetail",
        query: {
          refresh: new Date() - 0,
          id,
        },
        title: "分销员详情",
      });
    },
    getRoleList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "memberRole",
        },
      }).then((res) => {
        this.roleList = res || [];
      });
    },
    getCompanyList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
        para: {},
      }).then((res) => {
        this.companyList = res || [];
      });
    },
    getDealersList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LIST,
        para: {},
      }).then((res) => {
        this.dealerList = res || [];
      });
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
  },
  created() {
    this.getRoleList();
    this.getCompanyList();
    this.getDealersList();
    this.getChannelList();
    this.getMemberList();
  },
};
</script>

<style lang="postcss" module="css">
.enabled {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #52c41a;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.disabled {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #ff4d4f;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
</style>
